<template>
  <div>
    <!-- 年度开工率 -->
    <Echart
      :options="options"
      id="bottomLeftChart"
      height="270px"
      width="100%"
    ></Echart>
  </div>
</template>

<script>
import Echart from "@/common/echart";
export default {
  data() {
    return {
      options: {},
    };
  },
  components: {
    Echart,
  },
  props: {
    cdata: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    cdata: {
      handler(newData) {
        this.options = {
          tooltip: {
            trigger: "axis",
            backgroundColor: "rgba(255,255,255,0.1)",
            axisPointer: {
              type: "shadow",
              label: {
                show: true,
                backgroundColor: "#7B7DDC",
              },
            },
          },
          legend: {
            data: ["处理中", "已处理", "未处理"],
            textStyle: {
              color: "#B4B4B4",
            },
            top: "20px",
            right: "10px",
          },
          grid: {
            top: "60px",
            left: "30px",
            right: "10px",
            bottom: "20px",
          },
          xAxis: {
            data: newData.category,
            axisLine: {
              lineStyle: {
                color: "#B4B4B4",
              },
            },
            axisTick: {
              show: false,
            },
          },
          yAxis: [
            {
              splitLine: {
                show: true,
                lineStyle: {
                  color: "rgba(32, 67, 110,0.5)",
                },
              },
              axisLine: {
                show: false,
              },

              axisLabel: {
                formatter: "{value} ",
              },
            },
            // {
            //   splitLine: { show: false },
            //   axisLine: {
            //     lineStyle: {
            //       color: "#B4B4B4",
            //     },
            //   },
            //   axisLabel: {
            //     formatter: "{value} ",
            //   },
            // },
          ],
          series: [
            {
              name: "处理中",
              type: "line",
              symbol: "none",
              itemStyle: {
                normal: {
                  color: "#5dc8c3",
                },
              },
              areaStyle: {
                color: "rgba(95, 205, 195, 0.5)",
              },
              data: newData.processing,
            },
            {
              name: "已处理",
              type: "line",
              symbol: "none",
              itemStyle: {
                normal: {
                  color: "#3d8ddf",
                },
              },
              areaStyle: {
                color: "rgba(64, 145, 225, 0.5)",
              },
              data: newData.processed,
            },
            {
              name: "未处理",
              type: "line",
              symbol: "none",
              itemStyle: {
                normal: {
                  color: "#d24c4d",
                },
              },
              areaStyle: {
                color: "rgba(203, 73, 74, 0.5)",
              },
              data: newData.notProcessed,
            },
          ],
        };
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>
